angular.module('impactx.rfx').controller('RFXSupplierContractSelectionCtrl', [
    'AppConfiguration',
    'TranslationService',
    '$mdDialog',
    RFXSupplierContractSelectionCtrl
]);

function RFXSupplierContractSelectionCtrl(AppConfiguration, TranslationService, $mdDialog) {
    var self = this;
    angular.extend(self.trns, {
        abort: TranslationService.get('abort'),
        apply: TranslationService.get('accept')
    });
    self.freeformOfferLotSelect = AppConfiguration.get('freeformOfferLotSelect');

    self.save = function () {
        var result = {};
        if (impactX.isDefined(self, 'lot.id')) {
            result.lot = self.lot;
        }
        if (impactX.isDefined(self, 'contract.id')) {
            result.csc = self.contract;
        }
        $mdDialog.hide(result);
    };

    self.abort = function () {
        $mdDialog.cancel();
    };
}